import React, {useEffect} from "react";
// import {
//   PlayerContainer,
//   ProgressBar,
//   ProgressContainer,
//   // VolumeControl,
// } from "./audio.style";
import { AudioControls } from "./controls/audio-controls";
import { useAudio } from "./context/audio-context";
import { useBookContext } from "../../../context/book/book-context";
import "./audio.css";
// import { UserService } from "../../../services/user";
import { UserService } from "../../../../../services/user";
import RDP_CONFIG from "../../../../../config";

const AudioPlayer = () => {
  const {
    audioRef,
    handleProgressChange,
    handleTimeUpdate,
    progress,
    handleNextPrevious,
    // audioPreferences,
    // handleVolumeChange,
  } = useAudio();
  useEffect(() => {
      console.log(audioRef);
      }, [audioRef]);
  const { currentChapter, setLoadingChunk } = useBookContext();

  const formatTime = (time) => {
    if (!time) return "00:00";
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = Math.floor(time % 60);
    return `${hours > 0 ? `${hours}:` : ""}${
      hours > 0 && minutes < 10 ? `0${minutes}` : minutes
    }:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  const getAudioUrl = (audio) => {
    var accessToken = UserService.getUser().access_token;
    const path = `https://${RDP_CONFIG.domain}/storage/${RDP_CONFIG.apiVersion}/content?uid=${audio}&project_key=${RDP_CONFIG.projectKey}&api_env=${RDP_CONFIG.apiEnv}&access_token=${accessToken}`
    // audio += "&access_token=" + accessToken;
    return path;
  }

  return (
    <div className="rdp-component-audiobook-player-container">
      <audio
        onWaiting={() => setLoadingChunk(true)}
        onCanPlayThrough={() => setLoadingChunk(false)}
        ref={audioRef}
        src={currentChapter && getAudioUrl(currentChapter.asset)}
        onTimeUpdate={handleTimeUpdate}
        onEnded={() => handleNextPrevious("next")}
        />

      <div className="rdp-component-audiobook-player-progress-container">
        {/* <p>{formatTime(audioRef.current.currentTime)}</p> */}
        <input className="rdp-component-audiobook-player-progress-bar"
          type="range"
          min="0"
          max="100"
          value={progress}
          onChange={handleProgressChange}
        />

        {/* <p>{formatTime(audioRef.currentd.duration)}</p> */}
      </div>

      <AudioControls />
      {/* 
      <VolumeControl>
        <label htmlFor="volume">Volume</label>
        <input
          type="range"
          id="volume"
          min="0"
          max="1"
          step="0.01"
          value={audioPreferences.volume}
          onChange={handleVolumeChange}
        />
      </VolumeControl> */}
    </div>
  );
};

export default AudioPlayer;
